import { useBusinessOrganizationPricingConfig } from '@sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useGeneratedGetPricingHubAgentRecsQuery } from '@sales-portal/domain/pricing/screens/overview/blocs/documents/pricing-hub-agent-recs.generated';
import { useMemo } from 'react';

export const usePricingHubAgentRecsLoader = () => {
  const { hasPricingAgentAccess } = useBusinessOrganizationPricingConfig();

  const { data, error, loading } = useGeneratedGetPricingHubAgentRecsQuery({
    fetchPolicy: 'cache-and-network',
    skip: !hasPricingAgentAccess,
  });

  return useMemo(
    () => ({
      agentRecs: data?.getPricingHubAgentRecs,
      error,
      isLoading: loading && !data,
    }),
    [data, error, loading],
  );
};
